import styled from 'styled-components';

export const Container = styled.div`
  .close {
    position: absolute;
    right: 21px;
    top: 19px;
    z-index: 11;
    color: ${(props) => props.theme.$black};
  }

  .bg-modal {
    background-color: ${(props) => props.theme.$dark_slate_blue};
  }
`;
